module.exports = __webpack_public_path__ + "img/noAddress@2x.a3c05a5c.png";